import React from "react";
import PageWrapper from "../components/PageWrapper";
import FAQSection from "../components/FAQSection";

export default function About() {
  return (
    <PageWrapper>
      <div style={{
        maxWidth: "900px",
        margin: "auto",
        padding: "32px 18px",
        borderRadius: "28px",
        background: "rgba(0,0,0,0.08)"
      }}>
        {/* --- ABOUT MONKZI --- */}
        <section style={{ marginBottom: "32px" }}>
          <h1 style={{ color: "#FFD700", fontSize: "2em", fontWeight: "bold", marginBottom: "16px" }}>
            🧘 About MONKZI
          </h1>
          <p style={{ color: "#e0e0e0", lineHeight: "1.7" }}>
            Deep in the digital jungle, MONKZI emerged as a meditative force among meme coins.
            Inspired by both zen calm and monkey chaos, $MONKZI blends viral meme culture with spiritual vibes,
            bringing together a community of degens and dreamers alike.<br /><br />
            MONKZI isn’t just for laughs—our roadmap includes a launchpad for indie projects, meme-based rewards, and community-driven mini-games.
            No presale, no whales—just the power of patience, memes, and banana energy.
          </p>
        </section>

        

        <FAQSection />
        {/* --- SOCIAL LINKS --- */}
        <div style={{
          marginTop: "38px",
          borderTop: "1.5px solid #404040",
          padding: "24px 0 8px 0",
          textAlign: "center"
        }}>
          <span style={{ fontWeight: "bold", marginRight: "18px", color: "#FFD700" }}>Follow us:</span>
          <a href="https://t.me/monkillaofficial" target="_blank" rel="noopener noreferrer" style={{ color: "#0088cc", margin: "0 14px", fontWeight: "bold" }}>Telegram</a>
          <a href="https://twitter.com/monkillacoin" target="_blank" rel="noopener noreferrer" style={{ color: "#1da1f2", margin: "0 14px", fontWeight: "bold" }}>X (Twitter)</a>
          <a href="https://instagram.com/monkilla.official" target="_blank" rel="noopener noreferrer" style={{ color: "#d6249f", margin: "0 14px", fontWeight: "bold" }}>Instagram</a>
          <a href="https://www.facebook.com/profile.php?id=61578002207190" target="_blank" rel="noopener noreferrer" style={{ color: "#d6249f", margin: "0 14px", fontWeight: "bold" }}>Facebook</a>
		<a href="https://discord.gg/q8MDWV4K" target="_blank" rel="noopener noreferrer" style={{ color: "#d6249f", margin: "0 14px", fontWeight: "bold" }}>Discord</a>
          <a href="mailto:info@monkilla.com" style={{ color: "#FFD700", margin: "0 14px", fontWeight: "bold" }}>Email</a>
        </div>
      </div>
    </PageWrapper>
  );
}
